<template>
  <transition name="fade">
    <div v-if="!cookiesConsent" class="cookies">
      <div class="cookies__content">
        <p>
          Nasza strona używa cookies. Dzięki nim możemy dostosowywać stronę do
          potrzeb użytkowników. Pliki są zapisame w przeklądarce. Więcej w
          Polityce Cookies. <a class="cookies__link" href="/files/Polityka_Cookies.pdf" target="_blank">Dowiedz się więcej</a>.
        </p>
        <button class="cookies__btn" @click="accept">akceptuje</button>
      </div>
    </div>
  </transition>
</template>

<script>
const COOKIES_KEY = 'cookies-consent'

export default {
  data () {
    return {
      cookiesConsent: window.localStorage.getItem(COOKIES_KEY) === 'true'
    }
  },
  methods: {
    accept () {
      window.localStorage.setItem(COOKIES_KEY, 'true')
      this.cookiesConsent = true
    }
  }
}
</script>

<style lang="scss" scoped>
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity .3s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }

  .cookies {
    position: fixed;
    bottom: 0;
    left: 0;

    width: 100%;
    padding: 16px 32px;
    background-color: rgba(#d0d0d0, .5);

    font-size: 12px;
    color: #000;
    z-index: 99;

    @include media-up(md) {
      padding: 20px;
      font-size: 18px;
    }

    &__content {
      max-width: 1280px;
      margin: 0 auto;
      line-height: 1.3;

      p {
        margin-top: 0;
      }
    }

    &__link {
      color: inherit;
      transition: opacity .25s;

      &:hover {
        opacity: .8;
      }
    }

    &__btn {
      @include reset-button;
      width: 190px;
      line-height: 36px;
      background-color: #000;
      color: #fff;
      margin-left: auto;
      display: block;
      cursor: pointer;
      transition: opacity .25s;

      &:hover {
        opacity: .8;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Cookies.vue